module.exports = __webpack_public_path__ + "static/media/solitary_03.cab87cd5.jpg";